import Index from 'src/pages/Inventory/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/inventory',
    name: 'Inventur',
    component: Index,
    meta: auth
  }
]
